__turbopack_context__.v({
  "black": "Buttons-module-scss-module__Slm62a__black",
  "brand-colors": "Buttons-module-scss-module__Slm62a__brand-colors",
  "brand-svg": "Buttons-module-scss-module__Slm62a__brand-svg",
  "button": "Buttons-module-scss-module__Slm62a__button",
  "button-brand-effects-NO_EFFECTS": "Buttons-module-scss-module__Slm62a__button-brand-effects-NO_EFFECTS",
  "button-brand-variant-OUTLINED": "Buttons-module-scss-module__Slm62a__button-brand-variant-OUTLINED",
  "button-loading": "Buttons-module-scss-module__Slm62a__button-loading",
  "button-outline-primary": "Buttons-module-scss-module__Slm62a__button-outline-primary",
  "button-pre-content": "Buttons-module-scss-module__Slm62a__button-pre-content",
  "button-primary": "Buttons-module-scss-module__Slm62a__button-primary",
  "button-round": "Buttons-module-scss-module__Slm62a__button-round",
  "button-round-only-icon": "Buttons-module-scss-module__Slm62a__button-round-only-icon",
  "button-square": "Buttons-module-scss-module__Slm62a__button-square",
  "button-text": "Buttons-module-scss-module__Slm62a__button-text",
  "button-text-LOWER_CASE": "Buttons-module-scss-module__Slm62a__button-text-LOWER_CASE",
  "button-text-PASCAL_CASE": "Buttons-module-scss-module__Slm62a__button-text-PASCAL_CASE",
  "button-text-UPPER_CASE": "Buttons-module-scss-module__Slm62a__button-text-UPPER_CASE",
  "button-tight": "Buttons-module-scss-module__Slm62a__button-tight",
  "center-icon": "Buttons-module-scss-module__Slm62a__center-icon",
  "desktop-button": "Buttons-module-scss-module__Slm62a__desktop-button",
  "disabled": "Buttons-module-scss-module__Slm62a__disabled",
  "leftIcon": "Buttons-module-scss-module__Slm62a__leftIcon",
  "mobile-button": "Buttons-module-scss-module__Slm62a__mobile-button",
  "rightIcon": "Buttons-module-scss-module__Slm62a__rightIcon",
  "spinner": "Buttons-module-scss-module__Slm62a__spinner",
  "text": "Buttons-module-scss-module__Slm62a__text",
  "text-has-icon": "Buttons-module-scss-module__Slm62a__text-has-icon",
  "visually-disabled": "Buttons-module-scss-module__Slm62a__visually-disabled",
  "white-background": "Buttons-module-scss-module__Slm62a__white-background",
});
